import COLORS from '../../../../../utils/constants/colors'

// Trigger styled to match the filled form fields: a single ~56px grey box with the label floating
// at the top-left (like the other fields), rendered as a button so it reads as clickable and shows
// no text caret.
const connectedGameFieldStyles = {
  wrapper: {
    position: 'relative',
    flex: 1,
  },
  field: {
    position: 'relative',
    width: '100%',
    minHeight: 56,
    borderRadius: 6,
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    textAlign: 'left',
    padding: '0 44px 8px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.09)',
    },
    '&.Mui-disabled': {
      cursor: 'default',
    },
  },
  label: {
    position: 'absolute',
    top: 8,
    left: 16,
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  value: {
    fontSize: '0.95rem',
    color: COLORS.black,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  placeholder: {
    fontSize: '0.95rem',
    color: 'rgba(0, 0, 0, 0.40)',
  },
  clear: {
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}

export default connectedGameFieldStyles
